import React, { Component } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";

import { Mutation } from "react-apollo";
import { Box } from "reflexbox";
import {
  Dialog,
  DialogType,
  DialogFooter
} from "office-ui-fabric-react/lib/Dialog";
import {
  CommandBarButton,
  DefaultButton,
  PrimaryButton
} from "office-ui-fabric-react/lib/Button";
import { ordersByShipmentId } from "../../queries/orders";


class SplitOrderDialog extends Component {
  constructor() {
    super();
    this.state = {
      isVisible: true
    };
  }

  _showDialog = () => {
    this.setState({ isVisible: false });
  };

  _closeDialog = () => {
    this.setState({ isVisible: true });
  };

  render() {
    return (
      <Box>
        <CommandBarButton
          iconProps={{ iconName: "SplitObject" }}
          styles={{ root: { padding: "10px" } }}
          title="Clone orders"
          disabled={this.props.id ? false : true}
          onClick={this._showDialog}
        />
        <Dialog
          hidden={this.state.isVisible}
          onDismiss={this._closeDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Clone order"
          }}
          modalProps={{
            isBlocking: true
          }}
        >
          <Mutation mutation={CLONE_ORDER}>
            {(mutate, { data }) => (
              <DialogFooter>
                <PrimaryButton
                  text="Clone"
                  onClick={e => {
                    e.preventDefault();
                    const orderId = this.props.order.id;
                    const shipmentId = this.props.shipment.id;
                    mutate({
                      refetchQueries: [
                        {
                          query: ordersByShipmentId,
                          variables: { id: shipmentId }
                        }
                      ],
                      variables: {
                        id: orderId
                      }
                    });
                  }}
                />
                <DefaultButton onClick={this._closeDialog} text="Cancel" />
              </DialogFooter>
            )}
          </Mutation>
        </Dialog>
      </Box>
    );
  }
}

const CLONE_ORDER = gql`
  mutation($id: Int!) {
    cloneOrder(input: { orderId: $id }) {
      orders {
        id
      }
    }
  }
`;

const mapStateToProps = state => {
  return {
    order: state.selected.order,
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(SplitOrderDialog);



// WEBPACK FOOTER //
// ./src/common/Forms/_SplitOrderDialog.js